<template>
  <div class="card manage-event-card columns">
    <div class="column is-2 has-text-centered-mobile">
      <figure class="image">
        <img
          v-lazy="event.imgUrl"
          style="max-height: 150px; width: auto; margin: 0 auto"
        />
      </figure>
    </div>
    <div class="column is-6">
      <h2 class="is-size-5 has-text-weight-bold">
        {{ event.eventname }}
        <span class="has-text-danger" v-if="!event.active">- Unpublished</span>
      </h2>
      <p class="is-size-7">
        {{ event.eventdate | formatDate }} -
        {{ event.eventenddate | formatDate }}
      </p>
      <p class="is-size-7 has-margin-top-15">
        <strong>Total Views:</strong> {{ event.views || 0 }}
        <strong>Total Registrations: </strong> {{ event.registrations || 0 }}
      </p>
    </div>
    <div class="column is-4 has-text-centered-mobile">
      <b-dropdown aria-role="list">
        <button slot="trigger" slot-scope="{ active }" class="button">
          <span>Manage</span>
          <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
        </button>

        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'EventDashboard',
              params: { eventid: event._id },
            }"
            >Dashboard</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item v-if="user.superadmin" aria-role="listitem" has-link>
          <a href="" @click.prevent="copyEvent(event)">Copy Event</a>
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'EditEventBasicInfo',
              params: { eventid: event._id },
            }"
            >Edit Event Details</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'EditEventOptions',
              params: { eventid: event._id },
            }"
            >Edit Event Options</router-link
          >
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageRegistrations',
              params: { eventid: event._id },
            }"
            >Entries</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item
          v-if="event && event.config && event.config.waitinglist"
          aria-role="listitem"
          has-link
        >
          <router-link
            :to="{
              name: 'ManageWaitingList',
              params: { eventid: event._id },
            }"
            >Waiting List</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageDivisions',
              params: { eventid: event._id },
            }"
            >Divisions</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageLeaderboard',
              params: { eventid: event._id },
            }"
            >Leaderboard</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageSpectators',
              params: { eventid: event._id },
            }"
            >Spectators</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageJudges',
              params: { eventid: event._id },
            }"
            >Judges</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageVolunteers',
              params: { eventid: event._id },
            }"
            >Volunteers</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageVendors',
              params: { eventid: event._id },
            }"
            >Vendors</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <router-link
            :to="{
              name: 'ManageVoucherCodes',
              params: { eventid: event._id },
            }"
            >Invite Links/Voucher Codes</router-link
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="populateLeaderboard()"
            >Populate Leaderboard</a
          >
        </b-dropdown-item>
        <b-dropdown-item
          aria-role="listitem"
          v-if="
            user.superadmin &&
            new Date(event.eventenddate) < new Date() &&
            !event.profilespopulated
          "
          has-link
        >
          <a href="" @click.prevent="populateProfiles()">Populate Profiles</a>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown aria-role="list">
        <button slot="trigger" slot-scope="{ active }" class="button">
          <span>View</span>
          <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
        </button>

        <b-dropdown-item aria-role="listitem" has-link>
          <a :href="`/event/${event.url}`" target="_blank">Event Page</a>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a :href="`/leaderboard/${event.url}`" target="_blank"
            >Leaderboard (Public Link)</a
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" has-link>
          <a :href="`/leaderboard/${event.url}?e=${event._id}`" target="_blank"
            >Leaderboard (Private Link)</a
          >
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a :href="`/schedule/${event.url}`" target="_blank">Schedule</a>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a :href="`/heats/${event.url}`" target="_blank">Heats</a>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a :href="`/print-waiver/${event.url}`" target="_blank"
            >Print Waiver</a
          >
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown aria-role="list">
        <button slot="trigger" slot-scope="{ active }" class="button">
          <span>Export</span>
          <b-icon :icon="active ? 'menu-up' : 'menu-down'"></b-icon>
        </button>

        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="exportEntries()">Entries</a>
        </b-dropdown-item>

        <b-dropdown-item
          aria-role="listitem"
          has-link
          v-if="event.entrytypes.includes('Team')"
        >
          <a href="" @click.prevent="exportTeamMembers()">Team Members</a>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="exportVolunteers()">Volunteers</a>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="exportSpectators()">Spectators</a>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="exportJudges()">Judges</a>
        </b-dropdown-item>

        <b-dropdown-item aria-role="listitem" has-link>
          <a href="" @click.prevent="exportVendors()">Vendors</a>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <CopyEventModal
      :show="showCopyModal"
      :event="event"
      @close-modal="showCopyModal = false"
    />
  </div>
</template>

<script>
import Utils from '@/mixins/utils'
import Filters from '@/mixins/filters'
import EventApi from '@/api/event'
import EventEntryApi from '@/api/event-entry'
import TeamMemberApi from '@/api/team-member'
import VolunteerApi from '@/api/volunteer'
import JudgeApi from '@/api/judge'
import SpectatorApi from '@/api/spectator'
import VendorApi from '@/api/vendor'
import LeaderboardApi from '@/api/leaderboard'
import { mapGetters } from 'vuex'
import CopyEventModal from '@/components/CopyEventModal'

export default {
  mixins: [Utils, Filters],
  components: {
    CopyEventModal,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showCopyModal: false,
      selectedevent: null,
    }
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    async copyEvent(event) {
      this.selectedevent = event
      this.showCopyModal = true
    },
    async exportEntries() {
      await EventEntryApi.export(this.event._id)
    },
    async exportTeamMembers() {
      await TeamMemberApi.export(this.event._id)
    },
    async exportVolunteers() {
      await VolunteerApi.export(this.event._id)
    },
    async exportJudges() {
      await JudgeApi.export(this.event._id)
    },
    async exportSpectators() {
      await SpectatorApi.export(this.event._id)
    },
    async exportVendors() {
      await VendorApi.export(this.event._id)
    },
    async populateLeaderboard() {
      await LeaderboardApi.populateLeaderboard(this.event._id)
      this.$buefy.toast.open({
        message: `Leaderboard populated successfully!`,
        position: 'is-top',
        type: 'is-success',
      })
    },
    async populateProfiles() {
      await EventApi.populateProfile(this.event)
      this.event.profilespopulated = true
      this.$buefy.toast.open({
        message: `Profiles populated successfully!`,
        position: 'is-top',
        type: 'is-success',
      })
    },
  },
}
</script>
